import dayjs from '../../../../utils/dayjsConfig'
import { routeBusinessLines } from './routeExecutionPdfBuilder'
import { buildTimestampControlKpis, buildTimestampControlRows } from '../timestampControlExportData'

const HEADERS = [
  'Fecha',
  'Código de usuario',
  'Usuario',
  'Código de cliente',
  'Cliente',
  'Hora de inicio',
  'Hora de finalización',
  'Duración de visita',
  'Dentro de geocerca',
  'Estado',
  'Latitud inicio',
  'Longitud inicio',
  'Latitud final',
  'Longitud final',
  'Ubicación inicio',
  'Ubicación final'
]

export const buildTimestampControlCsvRows = ({
  results = [],
  timestampSummary = {},
  isTimestampSameDay,
  business,
  salesmanName,
  salesmanCode,
  startDate,
  endDate
}) => [
  ['REPORTE:', 'Control de horario'],
  ...routeBusinessLines(business).map((line) => [line]),
  ['USUARIO:', [salesmanCode, salesmanName].filter(Boolean).join(' - ') || 'N/A'],
  ['PERÍODO:', `${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`],
  ['GENERADO:', dayjs().format('DD/MM/YYYY HH:mm:ss')],
  [],
  ['KPI', 'VALOR', 'DESCRIPCIÓN'],
  ...buildTimestampControlKpis(timestampSummary, isTimestampSameDay).map((card) => [
    card.title,
    card.value,
    card.footer
  ]),
  [],
  HEADERS,
  ...buildTimestampControlRows(results).map((row) => [
    row.date,
    row.raw.salesman_db_ref || salesmanCode || '-',
    row.raw.salesman_name || salesmanName || '-',
    row.raw.client_db_ref || row.raw.client_uid || '-',
    row.client,
    row.start,
    row.end,
    row.duration,
    row.geofence,
    row.completed ? 'Finalizada' : 'En curso',
    row.raw.start_latitude ?? '-',
    row.raw.start_longitude ?? '-',
    row.completed ? (row.raw.end_latitude ?? '-') : '-',
    row.completed ? (row.raw.end_longitude ?? '-') : '-',
    row.startUrl || '-',
    row.endUrl || '-'
  ]),
  ...(results.length ? [] : [['No hay resultados', ...Array(HEADERS.length - 1).fill('')]])
]
